/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 演出分类,搜索查询,查询巡演数据
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  condition: good.CategoryCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.RecommendProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/tours`,
    data: condition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
